import { bulletIconSvg } from 'Guide/bullet_icons';

/**
 * The canonical step-line bullet palette — the single source of truth shared by
 * the guide editor (Guide/Edit/v2), the translation editor (Guide/Translate/v2),
 * and the guide embed reader (Guide/embed).
 *
 * The color hex values mirror the `@markup-*` variables in
 * UI/templates/css/variables.less, and the icon-bullet colors mirror
 * UI/templates/css/Guide/bullets.less (caution #ed1c24, note/reminder #666), so
 * the bullet a reader sees matches the marker an author draws on the step image
 * and the color the editor previews. `black` renders with @color-gray-900
 * (#111827) like the published guide.
 */
export const COLOR_BULLETS = [
   { name: 'black', hex: '#111827' },
   { name: 'red', hex: '#c1280b' },
   { name: 'orange', hex: '#ff9024' },
   { name: 'yellow', hex: '#f3e00e' },
   { name: 'green', hex: '#16dc81' },
   { name: 'light_blue', hex: '#15a1d6' },
   { name: 'blue', hex: '#2343e8' },
   { name: 'violet', hex: '#dc54b7' },
] as const;

export const ICON_BULLETS = [
   { name: 'icon_caution', hex: '#ed1c24' },
   { name: 'icon_note', hex: '#666666' },
   { name: 'icon_reminder', hex: '#666666' },
] as const;

export function isIconBullet(name: string): boolean {
   return ICON_BULLETS.some(bullet => bullet.name === name);
}

export function bulletColor(name: string): string {
   const color = COLOR_BULLETS.find(bullet => bullet.name === name);
   if (color) {
      return color.hex;
   }
   const icon = ICON_BULLETS.find(bullet => bullet.name === name);
   return icon ? icon.hex : '#111827';
}

/** Raw SVG markup for the three icon bullets; empty string for color bullets. */
export function bulletSvg(name: string): string {
   return isIconBullet(name) ? bulletIconSvg(name) : '';
}
